import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=afd05712&scoped=true"
import script from "./TabsView.vue?vue&type=script&lang=js"
export * from "./TabsView.vue?vue&type=script&lang=js"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=afd05712&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd05712",
  null
  
)

export default component.exports